import { Group, GROUP_ACCOUNT_OVERVIEW } from "types/Models/group";
import { emptyApi } from "./emptyApi";
import { TaskStats, UpcomingDeadlineData } from "types/Models/taxHome";
import { stringify } from "qs";

export const taxHomePageApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getTaxHomePageStats: build.query<
      TaskStats,
      { groupId: string; season: string }
    >({
      query: ({ groupId, season }) => {
        return `/api/inkle/tasks/group/${groupId}/home_page/stats/?season=${season}`;
      },
      providesTags: (result) => (result ? [{ type: "TAX_STATS" }] : []),
    }),

    getTaxHomePageDeadlines: build.query<
      UpcomingDeadlineData,
      { groupId: string; season: number }
    >({
      query: ({ groupId, season }) => {
        return `/api/inkle/tasks/group/${groupId}/upcoming_deadline/?season=${season}`;
      },
      providesTags: (result) =>
        result ? [{ type: "TAX_HOME_UPCOMING_DEADLINE" }] : [],
    }),

    getFreeFilingBannerDetails: build.query<
      UpcomingDeadlineData | {},
      { groupId: string; season?: number }
    >({
      query: ({ groupId, season }) => {
        let queryUrl = stringify(
          {
            season,
          },
          { skipNulls: true, addQueryPrefix: true }
        );
        return `/api/inkle/tasks/group/${groupId}/free_filing_banner/${queryUrl}`;
      },
      providesTags: (result) =>
        result ? [{ type: "TAX_HOME_UPCOMING_DEADLINE" }] : [],
    }),

    addTaskItemsToCart: build.mutation<
      any,
      {
        groupId: string;
        entityId: string;
        season: string;
        taskTemplateIds: string;
      }
    >({
      query: ({ groupId, entityId, season, taskTemplateIds }) => {
        return {
          url: `/api/inkle/tasks/group/${groupId}/entity/${entityId}/bulk_load/cart/?season=${season}&task_template_ids=${taskTemplateIds}`,
          method: "POST",
        };
      },
      invalidatesTags: ["CART"],
    }),

    addAlarmsToCart: build.mutation<
      void,
      {
        entityId: string;
        season: string;
      }
    >({
      query: ({ entityId, season }) => {
        return {
          url: `/api/inkle/billing/entity/${entityId}/cart/alarm_items/`,
          method: "POST",
          body: { season },
        };
      },
      invalidatesTags: ["CART", "UNLAUNCHED_TASK_LIST"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTaxHomePageStatsQuery,
  useGetTaxHomePageDeadlinesQuery,
  useAddTaskItemsToCartMutation,
  useAddAlarmsToCartMutation,
  useLazyGetTaxHomePageStatsQuery,
  useGetFreeFilingBannerDetailsQuery,
} = taxHomePageApi;
